import SearchIcon from "@mui/icons-material/Search";
import { Button } from "@mui/material";
import { t } from "i18next";
export function SearchOtherClientButton(props) {
    return (
        <Button startIcon={<SearchIcon />} variant={"outlined"} color={"primary"} {...props}>
            {t("clients.connectedPersonDialog.searchClient")}
        </Button>
    );
}
